/*	Example Usage

 //IF USING HORIZONTAL  - be careful of how you arrange elements. White space can throw the side to side scrolling off because of display:inline-block
 <div data-scroll-container options="scrollOptions">
     <div class="scrollContainer">
         <div style="height:50px;text-align:center;background-color:red;"><span>Item 1</span>
         </div><div style="height:50px;text-align:center;background-color:orange;"><span>Item 2</span>
         </div><div style="height:50px;text-align:center;background-color:yellow;"><span>Item 3</span>
         </div><div style="height:50px;text-align:center;background-color:green;"><span>Item 4</span>
         </div><div style="height:50px;text-align:center;background-color:blue;"><span>Item 5</span>
         </div><div style="height:50px;text-align:center;background-color:indigo;"><span>Item 6</span></div>
     </div>
 </div>

 $scope.scrollOptions = {
     autoWidth: true,   //controls if the width is automatically calculated. If flagged false, snap will be defaulted to false and show to 1.
     swipe: true,   // Controls if the scroller responds to swipe gestures
     snap: true,    // Controls if the scroller will lock to a grid when releasing a drag
     vertical: true, // Controls if the scroller is vertical. Default is false (horizontal)
     show: 2,       // Controls how many items to show at once. The scroll containers height will be the item height set above multiplied by this value. Defaults to 1.
     count: 6,      // The current count of items. This must be updated in javascript each time this count changes. Scroller will not work without count.
     enableLooping: true,   //controls if the slider will loop (connects the beginning and end elements)
     showNavigation: true, //shows navigation arrows
     goToCallback: function(pos, oldPos){   //callback function, gets passed the newPosition and oldPosition after a drag move
         console.log("callback function");
         console.log("oldPos: " + oldPos);
         console.log("newPos: " + pos);
     }
 };

 */

//long term to-do list
//TODO Look into implementing an x and y tracking so you can drag in two dimensions. Look @ developer.js

module.exports = function(app){
    'use strict';
    app.directive('scrollContainer', ['$window', '$compile', function($window, $compile){
            return {
                scope: {
                    options: "="
                },
                link: function(scope, element/*, attrs*/){

                    window.scrollScope = scope;
                    var options = scope.options,
                        navigationArrows = {
                            top: null,
                            bottom: null,
                            left: null,
                            right: null
                        };

                    var container = element,
                        scroller = element.children(0),
                        children = scroller.children(),
                        oldVal,
                        vertical = options.vertical,
                        scrollbarX = options.scrollbarX || options.scrollbarx,    //TODO where to get the scrollbars?
                        scrollbarY = options.scrollbarY || options.scrollbary;

                    //remove white space because of inline-block
                    scroller.contents().each(function(index,element) {
                        if (element.nodeType === 3) { // If node is a text node(nodetype=3), it's white space. remove it
                            $(element).remove();
                        }
                    });

                    if(options.autoWidth === false){
                        options.snap = false;
                        options.show = 1;
                    } else {
                        options.show = options.show || 1;
                    }

                    options.touchPosition = 0;
                    options.pos = options.pos || 0;
                    options.oldPos = options.pos;

                    var clientX, clientY, startTime, allowMove = false;
                    $(scroller).on('touchstart mousedown', function(evt) {
                        oldVal = options.touchPosition;
                        allowMove = true;
                        startTime = evt.timeStamp;

                        if(evt.originalEvent && evt.originalEvent.touches){
                            clientX = evt.originalEvent.touches[0].clientX;
                            clientY = evt.originalEvent.touches[0].clientY;
                        }
                        else {
                            clientX = evt.clientX;
                            clientY = evt.clientY;
                        }

                        if(evt.stopPropagation) evt.stopPropagation(); if(evt.preventDefault) evt.preventDefault(); evt.cancelBubble=true; evt.returnValue=false; return false;
                    });
                    $(scroller).on('touchmove mousemove', function(evt) {
                        if(allowMove){
                            var delta;

                            if(evt.originalEvent.touches && vertical) {
                                delta = evt.originalEvent.touches[0].clientY - clientY;
                            }
                            else if(evt.originalEvent.touches && !vertical){
                                delta = evt.originalEvent.touches[0].clientX - clientX;
                            }
                            else if (vertical){
                                delta = evt.clientY - clientY;
                            }
                            else{
                                delta = evt.clientX - clientX;
                            }

                            var newTouchPosition = oldVal + delta;
                            var totalSize = options.itemSize * options.count;
                            var upperBound = vertical ? totalSize - $(container).height() : totalSize - $(container).width();

                            if (newTouchPosition <= 0 && newTouchPosition >= upperBound * -1) { //checking to make sure we're within the bounds
                                options.touchPosition = newTouchPosition;
                                if (vertical && scrollbarY) {
                                    $(container)[0].scrollTop = newTouchPosition * -1;
                                }
                                else if (vertical && !scrollbarY){
                                    translateY(scroller, newTouchPosition);
                                }
                                else if (scrollbarX){
                                    $(container)[0].scrollLeft = newTouchPosition * -1;
                                }
                                else {
                                    translateX(scroller, newTouchPosition);
                                }
                            }

                            if(evt.stopPropagation) evt.stopPropagation(); if(evt.preventDefault) evt.preventDefault(); evt.cancelBubble=true; evt.returnValue=false; return false;
                        }
                    });
                    function addEvent(obj, evt, fn) {
                        if (obj.addEventListener) {
                            obj.addEventListener(evt, fn, false);
                        }
                        else if (obj.attachEvent) {
                            obj.attachEvent("on" + evt, fn);
                        }
                    }
                    addEvent(document, "mouseout", function(e) {
                        e = e ? e : window.event;
                        var from = e.relatedTarget || e.toElement;
                        if (!from || from.nodeName === "HTML") {
                            // stop your drag event here
                            // for now we can just use an alert
                            allowMove = false;
                            oldVal = undefined;
                        }
                    });
                    $(scroller).on('touchend mouseup', function(evt) {
                        if(allowMove){
                            var deltaX = evt.clientX - clientX,
                            //deltaY = evt.clientY - clientY,
                                deltaTime = evt.timeStamp - startTime,
                                velocityX = deltaX/deltaTime;
                            //velocityY = deltaY/deltaTime;
//                            console.log("deltaX: ", deltaX);
//                            console.log("deltaTime: ", deltaTime);
//                            console.log("velocity: ", velocityX);

                            //TODO: velocity could be configurable if we wanted to allow different swipe speeds
                            if(options.swipe && Math.abs(velocityX) > 0.70){
                                if(velocityX > 0){ //positive velocity is go previous
                                    options.goPrev();
                                }
                                else{ //negative velocity is go next
                                    options.goNext();
                                }
                            } else {
                                var newPos;
                                if (options.snap) {
                                    // Only move position if snapping is enabled
                                    newPos = Math.round(options.touchPosition / options.itemSize * -1);
                                    options.goTo(newPos);
                                } else {
                                    //callback function even if snapping is off so it keeps loose track of which item is being displayed
                                    newPos = Math.round(options.touchPosition / options.itemSize * -1);
                                    options.oldPos = options.pos;
                                    options.pos = newPos;
                                    if (options.goToCallback) {
                                        options.goToCallback(options.pos, options.oldPos);
                                    }
                                }
                            }

                            allowMove = false;
                            oldVal = undefined;

                            if(evt.stopPropagation) evt.stopPropagation(); if(evt.preventDefault) evt.preventDefault(); evt.cancelBubble=true; evt.returnValue=false; return false;
                        }
                    });

                    //function that controls moving to a particular position
                    //TODO: Look into implementing animated transforms again (translateX, translateY). Use Modernizr to check for compatibility
                    options.goTo = function(pos) {
                        //check to override pos if show and count are the same
                        if(options.show === options.count){
                            pos = 0;
                        }
                        options.oldPos = options.pos;
                        var newTouchPosition = options.itemSize * -1 * pos;

                        $(scroller).stop(); //stopping any animations before starting the next

                        if (vertical) {
                            if (scrollbarY) {
                                $(container).animate({ scrollTop: newTouchPosition * -1 });
                            }
                            else {
                                if (Modernizr.csstransforms) {
                                    $(scroller).css({
                                        'transform': 'translateY(' + newTouchPosition + 'px)',
                                        'transition': 'transform 1s'
                                    });
                                }
                                else {
                                    $(scroller).animate({'top': newTouchPosition + 'px'});
                                }
                            }
                        }
                        else {
                            if (scrollbarX) {
                                $(container).animate({ scrollLeft: newTouchPosition * -1 });
                            }
                            else {
                                if (Modernizr.csstransforms) {
                                    $(scroller).css({
                                        'transform': 'translateX(' + newTouchPosition + 'px)',
                                        'transition': 'transform 1s'
                                    });
                                }
                                else {
                                    $(scroller).animate({'left': newTouchPosition + 'px'});
                                }
                            }
                        }

                        options.touchPosition = newTouchPosition;
                        options.pos = pos;
                        if (options.goToCallback) {
                            options.goToCallback(options.pos, options.oldPos);
                        }
                    };
                    scope.goTo = options.goTo;

                    options.goPrev = function() {
                        if (options.pos > 0) {
                            options.goTo(options.pos - 1);
                        }
                        else if (options.enableLooping) {
                            options.goTo(options.count - options.show);
                        }
                    };

                    options.goNext = function() {
                        if (options.pos < options.count - options.show) {
                            options.goTo(options.pos + 1);
                        }
                        else if (options.enableLooping) {
                            options.goTo(0);
                        }
                    };

                    //function handles the default css styles for the directive
                    function applyCssStyles(){
                        children = scroller.children();

                        //only want these to run once
                        if(!options.containerSetup){
                            //initial directive container styling
                            angular.element(container).css({
                                'overflow-x': scrollbarX ? 'scroll' : 'hidden',
                                'overflow-y': scrollbarY ? 'scroll' : 'hidden',
                                'position': 'relative'
                            });

                            //initial slider(first child) styling
                            angular.element(scroller).css({
                                'position': 'relative',
                                'top': '0px',
                                'left': '0px'
                            });
                            options.containerSetup = true;
                        }

                        setChildrenWidth();
                        setChildrenCssLayout();
                        if(options.showNavigation && !options.navigationCreated){
                            createCssNavigation();
                            styleCssNavigation();
                        } else if (options.showNavigation && options.navigationCreated){
                            styleCssNavigation();
                        }
                    }

                    // Size needs recalculated when the window size changes, or when mobile screens are rotated.  After size is recalculated
                    // we need to reset the view on the current card
                    function adjustCardSize() {
                        if (vertical && children.length) {
                            //jquery .width and .outerWidth methods round, which is an issue for snapping.
                            //options.itemSize = angular.element(children[0]).outerHeight();
                            options.itemSize = children[0].getBoundingClientRect().height;
                        }
                        else if(children.length){
                            //jquery .width and .outerWidth methods round, which is an issue for snapping.
                            //options.itemSize = angular.element(children[0]).outerWidth();
                            var leftMargin = parseFloat($(children[0]).css("marginLeft").replace('px', '').replace('%', '')),
                                rightMargin = parseFloat($(children[0]).css("marginRight").replace('px', '').replace('%', ''));
                            options.itemSize = children[0].getBoundingClientRect().width + leftMargin + rightMargin;
                        }
                        options.goTo(options.pos);
                    }

                    function setChildrenWidth(){
                        //default width
                        var itemWidth = '100%',
                            counter = 0;

                        //if autowidth is true, loop through the children and apply the width
                        if(options.autoWidth){
                            if(!options.vertical){
                                //total width is 100% - 2% for every item shown (left & right margins are 1% each)
                                var totalWidth = (100 - (options.count * 2));
                                itemWidth = (totalWidth/options.show).toFixed(2) + '%';
                            }
                            for(counter;  counter < children.length; counter++){
                                angular.element(children[counter]).css('width', itemWidth);
                                angular.element(children[counter]).css({'marginLeft': '1%', 'marginRight': '1%'});
                                //if(counter === 0){
                                //    angular.element(children[counter]).css('marginRight', '1%');
                                //}
                                //else if (counter === options.count-1){
                                //    angular.element(children[counter]).css('marginLeft', '1%');
                                //}
                                //else{
                                //    angular.element(children[counter]).css({'marginLeft': '1%', 'marginRight': '1%'});
                                //}
                            }
                        }
                    }

                    function setChildrenCssLayout(){
                        var counter = 0;

                        //if statement should setup children of the scroller to either flow horizontally or vertically
                        if (vertical) { //if vertical is turned on, set the height of the container leaving
                            options.height = angular.element(children[0]).height();
                            angular.element(container).css('height', (options.height * options.show)+'px');
                        }
                        else {  //if horizontal, turn the white-space css property to nowrap & apply the inline-block to children elements
                            counter = 0;
                            angular.element(scroller).css('white-space', 'nowrap');
                            for(counter;  counter < children.length; counter++){
                                angular.element(children[counter]).css({'display': 'inline-block', 'vertical-align': 'top'});
                            }
                        }

                        var i = 0;
                        for(i;  i < children.length; i++){
                            angular.element(children[i]).css('white-space', 'normal');
                        }
                    }

                    scope.showPreviousArrow = function(){
                        var showPreviousArrow = null;
                        var showEqualCount = options.show === options.count;

                        var showArrows = !showEqualCount; //if they are equal, we don't want to show the arrows. No point because you're showing the entire count.

                        if(showArrows && options.pos === 0 && options.enableLooping){
                            showPreviousArrow = true; //Arrows should be shown, and we're on the first element, and looping is enabled, show the previous arrow
                        } else if(showArrows && options.pos === 0 && !options.enableLooping){
                            showPreviousArrow = false; //Arrows should be shown, and we're on the first element, but looping is disabled. Don't show the previous arrow.
                        } else if(showArrows && options.pos !== 0){
                            showPreviousArrow = true;  //Arrows should be shown, and we're not on the first element. Show the previous arrow.
                        }

                        return showPreviousArrow;
                    };

                    scope.showNextArrow = function(){
                        var showNextArrow = null;
                        var showEqualCount = options.show === options.count;

                        var showArrows = !showEqualCount; //if they are equal, we don't want to show the arrows. No point because you're showing the entire count.

                        if(showArrows && options.pos === options.count-options.show && options.enableLooping){
                            showNextArrow = true; //Arrows should be shown, and we're on the last element, and looping is enabled, show the next arrow
                        } else if(showArrows && options.pos === options.count-options.show && !options.enableLooping){
                            showNextArrow = false; //Arrows should be shown, and we're on the last element, but looping is disabled. Don't show the next arrow.
                        } else if(showArrows && options.pos !== options.count-options.show){
                            showNextArrow = true;  //Arrows should be shown, and we're not on the last element. Show the next arrow.
                        }

                        return showNextArrow;
                    };

                    function createCssNavigation(){
                        if(vertical){
                            navigationArrows.top = angular.element("<div></div>");
                            navigationArrows.bottom = angular.element("<div></div>");

                            navigationArrows.top.on('click', options.goPrev);
                            navigationArrows.bottom.on('click', options.goNext);

                            //kill me, I'm using compile again
                            $compile(navigationArrows.top)(scope);
                            $compile(navigationArrows.bottom)(scope);

                            element.append(navigationArrows.top, navigationArrows.bottom);
                        }
                        else {
                            navigationArrows.left = angular.element("<div data-ng-show='showPreviousArrow()'></div>");
                            navigationArrows.right = angular.element("<div data-ng-show='showNextArrow()'></div>");

                            navigationArrows.left.on('click', options.goPrev);
                            navigationArrows.right.on('click', options.goNext);

                            //kill me, I'm using compile again
                            $compile(navigationArrows.left)(scope);
                            $compile(navigationArrows.right)(scope);

                            element.append(navigationArrows.left, navigationArrows.right);
                        }

                        options.navigationCreated = true;
                    }

                    function styleCssNavigation(){
                        var containerHeight = 0;
                        if(vertical){
                            containerHeight = container.height();

                            var containerWidth = container.width(),
                                borderWidth = containerWidth * 0.1,
                                borderHeight = containerHeight * 0.1,
                                left = 0, right = 0;

                            //capping the borderHeight and borderWidth to a range 25 <= x <= 50
                            if(borderHeight < 25){
                                borderHeight = 25;
                            } else if (borderHeight > 50){
                                borderHeight = 50;
                            }

                            if(borderWidth < 25){
                                borderWidth = 25;
                            } else if (borderWidth > 50){
                                borderWidth = 50;
                            }

                            if(containerHeight > 4*borderHeight){
                                left = right = (containerWidth - (borderWidth * 2))/2;
                            } else {
                                borderHeight = containerHeight;
                                borderWidth = borderWidth / 2;
                            }

                            navigationArrows.top.css(
                                {
                                    'position': 'absolute',
                                    'top': '0px',
                                    'left': left+'px',
                                    'z-index':'1',
                                    'border-left': borderWidth + 'px solid transparent',
                                    'border-right':borderWidth +'px solid transparent',
                                    'border-bottom': borderHeight +'px solid black',
                                    'opacity': '0.5'
                                }
                            );

                            navigationArrows.bottom.css(
                                {
                                    'position': 'absolute',
                                    'bottom': '0px',
                                    'right': right+'px',
                                    'z-index':'1',
                                    'border-left': borderWidth + 'px solid transparent',
                                    'border-right':borderWidth +'px solid transparent',
                                    'border-top': borderHeight +'px solid black',
                                    'opacity': '0.5'
                                }
                            );

                        } else {
                            containerHeight = container.height();

                            var borderSize = containerHeight * 0.4;
                            //capping arrow size
                            borderSize = borderSize >= 50 ? 50 : borderSize;
                            var top = (containerHeight - (borderSize * 2))/2;  //height - border size * 2 gives you remaining space after arrow. Top will be half of that.

                            navigationArrows.left.css(
                                {
                                    'position': 'absolute',
                                    'top': top + 'px',
                                    'left':'0px',
                                    'z-index':'1',
                                    'border-top': borderSize + 'px solid transparent',
                                    'border-bottom':borderSize +'px solid transparent',
                                    'border-right': borderSize +'px solid black',
                                    'opacity': '0.5'
                                }
                            );

                            navigationArrows.right.css(
                                {
                                    'position': 'absolute',
                                    'top': top + 'px',
                                    'right':'0px',
                                    'z-index':'1',
                                    'border-top': borderSize + 'px solid transparent',
                                    'border-bottom':borderSize +'px solid transparent',
                                    'border-left': borderSize +'px solid black',
                                    'opacity': '0.5'
                                }
                            );
                        }
                    }

                    function translateX(node, val) {
                        if (Modernizr.csstransforms) {
                            angular.element(node).css({
                                'transform': 'translateX(' + val + 'px)',
                                'transition': 'transform 0s'
                            });
                        }
                        else {
                            angular.element(node).css('left', val+'px');
                        }
                    }

                    function translateY(node, val) {
                        if (Modernizr.csstransforms) {
                            angular.element(node).css({
                                'transform': 'translateY(' + val + 'px)',
                                'transition': 'transform 0s'
                            });
                        }
                        else {
                            angular.element(node).css('top', val+'px');
                        }
                    }

                    //listener to fire the adjustCardSize function on window resize
//                    angular.element($window).on('resize', function(){
//                        setTimeout(adjustCardSize(), 500);
//                    });

                    //listener to update the show. Only listens if autoWidth is on
                    if(options.autoWidth){
                        scope.$watch('options.show', function(){
                            applyCssStyles();
                            adjustCardSize();
                        });
                    }

                    //this watch fires initially, to setup the styles on load
                    scope.$watch('options.count', function(){
                        applyCssStyles();
                        adjustCardSize();
                    });

                    //sometimes the page templates take forever to load. WHen they do, broadcast this event and it'll setup the nav css
                    scope.$on('scrollContainerNavReadyForSetup', function(){
                        styleCssNavigation();
                    });

                    scope.$watch(
                        function(){
                            return scroller.children().length;
                        },
                        function(){
                            children = scroller.children();
                            applyCssStyles();
                            adjustCardSize();
                        }
                    );
                }
            };
        }]
    );
    app.service('scrollContainerService',[function(){
        this.setCssStyles = function(){};
    }]);
};
